var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import { t } from 'i18next';
import '../../components/textArea';
import { feedbackContext } from './FeedbackContext';
import { consume } from '@lit-labs/context';
let TextReveiw = class TextReveiw extends BaseComponent {
    render() {
        const { textReview } = this.questionsAndStatus;
        const { tradeRole } = this.questionsAndStatus.feedbackStatusAndQuestions;
        return html `
      <trust-text-area
        autoFocus
        dataTest="text-review"
        value='${textReview}'
        maxLength=2000
        placeHolder="${t('Write your review here')}"
      ></trust-text-area>
      <p class=${`mt-4 detail ${textReview.length === 2000 ? 'text-red-600' : ''}`}>
        ${textReview.length}/2000.
        ${t('The comment is shown on the {{roles}} profile', { roles: tradeRole !== 'SELLER' ? t('seller\'s') : t('buyer\'s') })}
      </p>
    `;
    }
};
__decorate([
    consume({ context: feedbackContext, subscribe: true })
], TextReveiw.prototype, "questionsAndStatus", void 0);
TextReveiw = __decorate([
    customElement('text-feedback-review')
], TextReveiw);
export { TextReveiw };
//# sourceMappingURL=TextReveiw.js.map